const NOISE_SVG =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3'/></filter><rect width='160' height='160' filter='url(%23n)'/></svg>";

export function Noise() {
  return (
    <>
      <div
        className="noise-layer"
        style={{
          zIndex: 60,
          opacity: 0.5,
          backgroundImage:
            "repeating-linear-gradient(to bottom, rgba(0,0,0,0.28) 0px, rgba(0,0,0,0.28) 1px, transparent 1px, transparent 3px)",
        }}
      />
      <div
        className="noise-layer"
        style={{
          zIndex: 61,
          opacity: 0.16,
          mixBlendMode: "overlay",
          backgroundImage: `url("${NOISE_SVG}")`,
        }}
      />
    </>
  );
}
